// Parsers for modifying API js object to usable format
// All functions are calculations (AKA pure functions)
// and utilize copy-on-write pattern

import receipt from "./receipt";
import date from "./date";
import splitRuleUTCMidnight from "./splitRuleUTCMidnight";
import formToSchedule from "./formToSchedule";
import filterPaymentReferenceTypes from "./filterPaymentReferenceTypes";

export const Parsers = {
  receipt,
  date,
  splitRuleUTCMidnight,
  formToSchedule,
  filterPaymentReferenceTypes,
};
